















































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';


@Component
export default class Formal extends Vue {
    private loading = false;

    private myLibraries: any[] = [];
    private curLibrary: any = {};
    private pagedData = [];
    private pageSize = 15;
    private pageIndex = 1;
    private total = 0;
    private multipleSelection: any[] = [];
    private hasChildren = false;

    private editFormVisible = false;
    private editForm: any = {};
    private fileList = [];
    private token = {
        "Authorization": "Bearer " + this.$store.state.token
    };

    private active = 0;

    // 布尔值格式化：cellValue为后台返回的值
    formatBoolean(row: any, column: any, cellValue: boolean) {
        let ret = ''  //你想在页面展示的值
        if (cellValue) {
            ret = "是"  //根据自己的需求设定
        } else {
            ret = "否"
        }
        return ret;
    }

    formatTimer(row: any, column: any, cellValue: number) {
        if (row.autoStart) {
            let date = new Date(cellValue);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            let d = date.getDate();
            let h = date.getHours();
            let m = date.getMinutes();
            let s = date.getSeconds();
            return `${y}-${MM}-${d} ${h}:${m}`;
        }
        else
            return "";
    }

    created() {
        this.reloadLibraries();
        this.reload();
    }

    reloadLibraries() {
        this.$apis.getMyLibraries(1, 0)
            .then((res: any) => {
                this.myLibraries = res.data;
            });
    }

    reload() {
        this.$apis.getFormals(this.hasChildren, this.pageIndex, this.pageSize)
            .then((res: any) => {
                this.total = res.total;
                this.pagedData = res.data;
            });
    }

    onLibrary(id: number) {
        for (let i = 0; i < this.myLibraries.length; ++i) {
            if (this.myLibraries[i].id == id) {
                this.curLibrary = this.myLibraries[i];
                this.editForm.libraryId = this.myLibraries[i].id;
                return;
            }
        }
    }

    // 页面尺寸变化
    onSizeChange(val: any) {
        this.pageSize = val;
        this.pageIndex = 1;
        this.reload();
    }

    // 当前页变化
    onCurrentChange(val: any) {
        this.pageIndex = val;
        this.reload();
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    onScore(row: any) {
        this.$router.push({ path: "/exam/record", query: { formalId: row.id, unitId: row.unitId } });
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的考试, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {

            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delFormals({ data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 新增
    onAdd() {
        let now = (new Date()).getTime();
        now += 3600000 - now % 3600000;
        this.editForm = {
            name: "",
            isExtra: false,
            time: 30,
            singleNum: 40,
            multipleNum: 40,
            judgeNum: 20,
            singleScore: 1,
            multipleScore: 1,
            judgeScore: 1,
            isOptionsRandom: false,
            enable: false,
            autoStart: false,
            beginTime: new Date(new Date(now)),
            endTime: new Date(now + 1800000)
        }
        this.active = 0;
        this.fileList = [];
        this.editFormVisible = true;
    }

    // 编辑
    onEdit(row: any) {
        let now = (new Date()).getTime();
        now += 3600000 - now % 3600000;
        this.onLibrary(row.libraryId); // 设置一下当前题库
        this.editForm = {
            id: row.id,
            libraryId: row.libraryId,
            isExtra: row.isExtra,
            name: row.name,
            time: row.time,
            singleNum: row.singleNum,
            multipleNum: row.multipleNum,
            judgeNum: row.judgeNum,
            singleRange: row.singleRange,
            multipleRange: row.multipleRange,
            judgeRange: row.judgeRange,
            singleScore: row.singleScore,
            multipleScore: row.multipleScore,
            judgeScore: row.judgeScore,
            isOptionsRandom: row.isOptionsRandom,
            enable: row.enable,
            autoStart: row.autoStart,
            beginTime: row.autoStart ? new Date(row.beginTime) : new Date(now),
            endTime: row.autoStart ? new Date(row.endTime) : new Date(now + row.time * 60000),
        }
        this.active = 0;
        this.fileList = [];
        this.editFormVisible = true;
    }

    // 提交
    onFinish() {
        this.editFormVisible = false;

        if (this.editForm.isExtra == false) {
            this.editForm.extraTopics = null;
        }

        if (typeof (this.editForm.id) == "undefined") {
            // 新增
            this.$apis.postFormal(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    });
                });
        } else {
            // 编辑
            this.$apis.putFormal(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表

                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                });
        }
    }

    onChange(file: any, fileList: []) {
        this.fileList = fileList;
        if (this.editForm.name == "")
            this.editForm.name = file.name.substring(0, file.name.lastIndexOf("."));
    }

    onSucess(res: any) {
        if (res.isSuccess) {
            this.editForm.extraTopics = res.data;

            this.$message({
                type: 'success',
                message: `已成功识别${this.editForm.extraTopics.length}道试题`
            });
        }
    }
    onExport(row: any) {
        this.$apis.getFormalExport(row.id)
            .then((res: any) => {
                const blob = new Blob([res], { type: 'text/csv' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = row.name + ".csv";
                a.click();
                window.URL.revokeObjectURL(url);
            });
    }

    onPreview() {

    }

}
